import { MobileNavbarWrapperGuest, MobileNavbarWrapperHost } from "./mobileNavbarStyling";
// Import search components
import MobileNavbarMenuItems from "./mobileNavbarMenuItems";
import { useRecoilValue } from "recoil";
import { useLocation } from "react-router-dom";
import useScrollDirection from "../../../hook/useScrollDirection";
import { hideNavbarState } from "@/state/atoms/hideNavbarState";
import { guestModeSelector } from "@/state/selectors/userModel";

export default function MobileNavbar() {
    const location = useLocation();
    const [scrollDirection, isHitBottom] = useScrollDirection(window);
    const isHidden = useRecoilValue(hideNavbarState);
    const isGuestMode = useRecoilValue(guestModeSelector);

    const hideNavbar = () => {
        return scrollDirection === "down" && !isHitBottom;
    };

    const notHideMobileNavbar = (pathname: string) => {
        const notHideOnPaths = ["/all-bookings", "/dashboard", "/inbox-lite", "/messages-lite", "/calendar", "/payouts", "/saved", "/profile", "/listings", "/trips"];
        return notHideOnPaths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
    };
    const notHide = notHideMobileNavbar(location.pathname);

    // Don't render the mobile navbar on search page or your-booking page
    if (location.pathname === "/search" || location.pathname.includes("/booking")) {
        return null;
    }

    const NavbarWrapper = isGuestMode ? MobileNavbarWrapperGuest : MobileNavbarWrapperHost;

    return (
        <NavbarWrapper
            location={location.pathname}
            hide={location.pathname === "/" ? false : location.pathname === "/search" ? isHidden : !notHide}
        >
            <MobileNavbarMenuItems />
        </NavbarWrapper>
    );
}
